<template>
	<div id="app">
		<router-view />
		<EnvironmentFloat :current-environment="currentEnvironment" @switch="switchToStandardEnv" />
	</div>
</template>

<script setup>
import { onBeforeUnmount, getCurrentInstance } from 'vue';
import { useVersion } from '@/hooks';
import { useEnvironment } from '@/hooks/useEnvironment';
import EnvironmentFloat from '@/components/EnvironmentFloat.vue';
import { APP_VERSION_NUMBER, CACHE_IR_VIRTUAL_SESSION, CACHE_IR_VIRTUAL_ID, CACHE_APP_ENTRY_URL } from '@/const/host';

// ===================== 缓存强刷检查 =====================
const { checkSameVersion, resetAppCache } = useVersion();
const checkVersion = () => {
	const sameVersion = checkSameVersion();
	if (!sameVersion) {
		// 如果版号不一致 说明需要手动重刷缓存
		console.log('refresh version.....................', APP_VERSION_NUMBER);
		resetAppCache();
	}
};
checkVersion();

const { currentEnvironment, handleEnvironment, switchToStandardEnv } = useEnvironment();
const vm = getCurrentInstance();
vm.proxy.$router.onReady(() => {
	handleEnvironment();
});

// ===================== 隐式ID访问检查 =====================
let configHandledFlag = false;
const onIrstoreConfigLoaded = e => {
	if (configHandledFlag) return;
	configHandledFlag = true;

	saveIdToCache(e?.detail?.id);
	const onceTag = sessionStorage.getItem(CACHE_IR_VIRTUAL_SESSION);
	if (!onceTag) {
		sessionStorage.setItem(CACHE_IR_VIRTUAL_SESSION, 1);
		redirectToLang();
	}
};
const saveIdToCache = id => {
	sessionStorage.setItem(CACHE_IR_VIRTUAL_ID, id);
};
// 根据 host 补全 lang 参数并跳转
const redirectToLang = () => {
	const { getHostInfo } = window.__COMEIN_IR_STORE__;
	const langInHost = getHostInfo?.().lang;
	if (langInHost) {
		const currentUrl = new URL(window.location.href);
		if (currentUrl.searchParams.get('lang')) return;
		currentUrl.searchParams.set('lang', langInHost);
		window.location.href = currentUrl.toString();
	}
};
// 域名访问场景检查
const domainSessionCheck = () => {
	const { isDomainAccessSession } = window.__COMEIN_IR_STORE__;
	const isDomainSession = isDomainAccessSession?.();
	console.log('________________________ isDomainSession:', isDomainSession);
	if (isDomainSession) {
		// 域名访问场景：隐式缓存ID
		const configId = window.__IRSTORE_CONFIG?.id;
		if (configId) {
			onIrstoreConfigLoaded({ detail: { id: configId } });
		} else {
			// 异步时序兼容
			window.addEventListener('IRSTORE_CONFIG_LOADED', onIrstoreConfigLoaded);
		}
	} else {
		// 非域名访问场景：常规路径ID流程
		sessionStorage.removeItem(CACHE_IR_VIRTUAL_SESSION);
		sessionStorage.removeItem(CACHE_IR_VIRTUAL_ID);
		sessionStorage.removeItem(CACHE_APP_ENTRY_URL);
	}
};
domainSessionCheck();
onBeforeUnmount(() => {
	window.removeEventListener('IRSTORE_CONFIG_LOADED', onIrstoreConfigLoaded);
});
</script>
